export const whiteColor = "#ffffff"
